import { render, staticRenderFns } from "./Crisis_report.vue?vue&type=template&id=582b09d6"
import script from "./Crisis_report.vue?vue&type=script&lang=js"
export * from "./Crisis_report.vue?vue&type=script&lang=js"
import style0 from "./Crisis_report.vue?vue&type=style&index=0&id=582b09d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports